import { UnauthorisedPage } from '@/pages/unauthorised';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/unauthorised')({
	component: UnauthorisedPage,
});
